var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AccordionGrid, AccordionGridItem, Separator, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { createGaEvent } from '../util/GaUtil';
import ActionsBlock from './ActionsBlock';
import BillingBlock from './BillingBlock';
import InvoiceList from './invoices/InvoiceList';
import ServicesBlock from './ServicesBlock';
import UserBlock from './UserBlock';
import { injectStores } from '../util/StoresUtil';
export const frontPageGaData = (blockName, eventLabel) => {
    createGaEvent({ eventCategory: 'Iseteenindus - Avaleht', eventAction: blockName, eventLabel });
};
let FrontPageBlocks = class FrontPageBlocks extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (React.createElement(AccordionGrid, { breakPoint: "md" },
            React.createElement(AccordionGridItem, { gridColumn: { width: ['xs-12', 'md-3'] }, accordionItem: { id: 'accordion-item-1' }, title: translate('frontPage.billing') },
                React.createElement(Text, null,
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(InvoiceList, null),
                    React.createElement(BillingBlock, null))),
            React.createElement(AccordionGridItem, { gridColumn: { width: ['md-3'] }, accordionItem: { id: 'accordion-item-2' }, title: translate('frontPage.services') },
                React.createElement(Text, null,
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(ServicesBlock, null))),
            React.createElement(AccordionGridItem, { gridColumn: { width: ['md-3'] }, accordionItem: { id: 'accordion-item-3' }, title: translate('frontPage.actions') },
                React.createElement(Text, null,
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(ActionsBlock, null))),
            React.createElement(AccordionGridItem, { gridColumn: { width: ['md-3'] }, accordionItem: { id: 'accordion-item-4' }, title: translate('frontPage.account') },
                React.createElement(Text, null,
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(UserBlock, null)))));
    }
};
FrontPageBlocks = __decorate([
    injectStores,
    observer
], FrontPageBlocks);
export default FrontPageBlocks;
